import React from 'react';
import { createRoot } from 'react-dom/client';
import $ from 'jquery';
import cleanObj from 'utils/cleanObj';
import FilteredListing from './index';

// Script to initialise Filter Listing React component on all .listing-app elements
$('.listing-app').each(function () {
    const appID = $(this).data('app-id');
    const $apiDataDiv = $(`.${appID}-api-json`);

    // Early return if div target is not specified
    if (!appID || !$apiDataDiv.length) { return; }

    // Setup props
    const props = {
        url: $apiDataDiv.data('api-url'),
        data: $apiDataDiv.html(),
        listingAppID: appID,
        tileType: $apiDataDiv.data('tile-type'),
        tileContainerColumnClass: $apiDataDiv.data('tile-container-column-class'),
        tileContainerTilesWrap: $apiDataDiv.data('tile-container-tile-wrap'),
        filtersLayout: $apiDataDiv.data('filters-layout')
    };

    // Remove any empty prop settings to let the default prop values kick in
    cleanObj(props);

    const root = createRoot($(this)[0]);
    root.render(
        React.createElement(FilteredListing, props, null)
    );
});

$(window).scroll(() => {
    const more = $('.js-react-load-more-on-scroll');
    if (more.length > 0) {
        if ($(window).scrollTop() + $(window).outerHeight() > more.offset().top + 100) {
            more.click();
        }
    }
});
